import { mapState } from 'vuex'
import privacySettings from './privacySettings'

const SCRIPT_LOAD_STATES = {
    NOT_LOADED: 'Not loaded',
    LOADING: 'loading',
    LOADED: 'loaded'
}

const FORM_STEPS = Object.freeze({
    'companyIndustry': '1|Company Industry',
    'activeRegions': '2|Active Regions',
    'annualShare': '3|Annual Share',
    'annualTurnover': '4|Annual Turnover',
    'showResult': '5| Show Result',
    'reCalculateResult': '5|Re Calculate Result',
    'contactUs': '6|Contact Us'
})

export default {
    mixins: [
        privacySettings
    ],
    data: function() {
        return {
            isAnalyticsConfigured: true,
            queue: [],
            scriptUrl: window.location.host === process.env.VUE_APP_HOST
                ? process.env.VUE_APP_TRACKING_ADOBE_SRC_PROD
                : process.env.VUE_APP_TRACKING_ADOBE_SRC_DEV,
            pageCountry: 'ch',
            applicationName: 'CurrencyCheck',
            analyticsFormName: 'CurrencyCheck'
        }
    },
    created() {
        window.digitalData = window.digitalData || {}
        this.scriptLoadState = this.isScriptLoaded(this.scriptUrl)
            ? SCRIPT_LOAD_STATES.LOADED
            : SCRIPT_LOAD_STATES.NOT_LOADED
    },
    computed: {
        ...mapState('app', [
            'language'
        ])
    },
    methods: {
        isScriptLoaded(src) {
            return document.querySelector('script[src="' + src + '"]')
        },
        loadScript() {
            if (!this.isAnalyticsConfigured ||
                this.scriptLoadState !== SCRIPT_LOAD_STATES.NOT_LOADED) {
                return
            }

            if (!this.scriptUrl) {
                console.log('Analytics: No script configured.')
                return
            }

            this.scriptLoadState = SCRIPT_LOAD_STATES.LOADING
            const script = document.createElement('script')

            script.onload = () => {
                this.scriptLoadState = SCRIPT_LOAD_STATES.LOADED
                this.queue.forEach(trackEvent => trackEvent())
                this.queue = []
            }
            script.src = this.scriptUrl
            window.document.body.appendChild(script)
        },
        trackPageView() {
            window.digitalData.page = {
                siteName: this.applicationName,
                pageName: 'Homepage',
                pageURL: window.location.href,
                userAgent: navigator.userAgent,
                pageCountry: 'ch',
                language: this.language
            }
            this.track('Site Page View')
        },
        trackCTAClick(option) {
            window.digitalData.CTAClick = {
                CTAName: option.CTAName,
                CTALink: option.CTALink
            }
            this.track('Site CTA Click', window.digitalData.CTAClick)
        },
        trackFormStart() {
            window.digitalData.form = {
                formName: this.analyticsFormName,
                formStepName: FORM_STEPS['companyIndustry']
            }
            this.track('Site Form Start', window.digitalData.form)
        },
        trackFormStep(step) {
            window.digitalData.form = {
                formName: this.analyticsFormName,
                formStepName: FORM_STEPS[step]
            }
            this.track('Site Form Step View', window.digitalData.form)
        },
        trackFormSuccess(step) {
            window.digitalData.form = {
                formName: this.analyticsFormName,
                formStepName: FORM_STEPS[step]
            }
            this.track('Site Form Completed', window.digitalData.form)
        },
        trackFormError(step, errorMessage) {
            window.digitalData.form = {
                formName: this.analyticsFormName,
                formStepName: FORM_STEPS[step],
                errorMessage: errorMessage
            }
            this.track('Site Form Error', window.digitalData.form)
        },
        track(event, data = null) {
            if (this.getPrivacySettings().analytics) {
                if (this.scriptLoadState === SCRIPT_LOAD_STATES.LOADED) {
                    window._satellite.track(event, data)
                } else {
                    if (this.scriptLoadState === SCRIPT_LOAD_STATES.NOT_LOADED) {
                        this.loadScript()
                    }
                    this.queue.push(() => window._satellite.track(event, data))
                }
            }
        }
    }
}
